import React from 'react';
import './Dalel.css';
import image2 from '../asserts/images/student6.jpeg';
import image1 from '../asserts/images/students2.jpeg';
import image3 from '../asserts/images/student3.jpg';
import image0 from '../asserts/images/student5.png';

const Dalel = () => {
  return (
       <div className='slides2'>
        <div style={{'--x': '0s'}}><img src={image1} alt="Image 1" /></div>
        <div style={{'--x': '4s'}}><img src={image2} alt="Image 2" /></div>
        <div style={{'--x': '8s'}}><img src={image3} alt="Image 3" /></div>
        <div style={{'--x': '12s'}}><img src={image0} alt="Image 4" /></div>
       </div>
      
   

  );
};

export default Dalel;
